import { render, staticRenderFns } from "./ProductUPC.vue?vue&type=template&id=e511e802"
import script from "./ProductUPC.vue?vue&type=script&lang=js"
export * from "./ProductUPC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports